import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    FETCH_LOCATIONS: 'FETCH_LOCATIONS',
    FETCH_SMART_LOCATIONS: 'FETCH_SMART_LOCATIONS',
    FETCH_COUNTRY_SUGGESTION: 'FETCH_COUNTRY_SUGGESTION',
    FETCH_CITY_SUGGESTION: 'FETCH_CITY_SUGGESTION',
    FETCH_STATE_SUGGESTION: 'FETCH_STATE_SUGGESTION'
  })
};

export const fetchSmartLocations = createAsyncAction(types.FETCH_SMART_LOCATIONS, (search) =>
  api.get(`v1/search-locations?keyword=${search}`).then((res) => res?.data)
);
